export interface Formation {
  id: string;
  title: string;
  school: string;
  location: string;
  startDate: string;
  endDate: string;
  description: string;
}

export const formations: Formation[] = [
  {
    id: 'chef-projet',
    title: 'Chef de Projet en Conception de Systèmes Informatiques',
    school: 'IMIE - Ecole de la Filière Numérique',
    location: 'Angers, France',
    startDate: '2016-01-01',
    endDate: '2017-01-01',
    description:
      "Bac+5, titre 'Chef de Projet en Conception de Systèmes Informatiques' homologué niveau 1 " +
      "par la Commission Technique d'Homologation des Titres et Diplômes de l'Enseignement " +
      'Technologique (code NSF 326n en partenariat avec AQUITCOM)',
  },
  {
    id: 'concepteur-dev',
    title: 'Concepteur Développeur Informatique',
    school: 'IMIE - Ecole de la Filière Numérique',
    location: 'Angers, France',
    startDate: '2014-01-01',
    endDate: '2016-01-01',
    description:
      "Le Concepteur Développeur en Projets Numériques prend en charge le développement d'applications " +
      "dans le cadre de projets dont l'objectif est l'automatisation de processus dans l'entreprise, " +
      'selon une démarche ' +
      "qualité. En relation avec son client, il analyse le fonctionnement de l'entreprise, définit les processus, " +
      "repère ceux qu'il est possible d'automatiser et en mesure le coût.",
  },
  {
    id: 'bts-slam',
    title: 'BTS SLAM : Solutions Logicielles et Applications Métiers',
    school: "Institut d'informatique appliquée",
    location: 'Angers, France',
    startDate: '2013-01-01',
    endDate: '2014-01-01',
    description:
      "L'option SLAM – Solutions Logicielles des Applications Métiers, prépare à la conception et à la" +
      ' maintenance de solutions logicielles applicatives. Analyser rapidement les besoins ' +
      'des utilisateurs et leur ' +
      "assurer l'assistance et la formation. Concevoir et développer des applications informatiques, de l'étude des" +
      ' besoins à la mise en œuvre du projet.',
  },
  {
    id: 'bac-pro',
    title: 'BAC Pro SEN Système Electronique Numérique',
    school: 'Lycée St Jean Baptiste de la Salle',
    location: 'Nantes, France',
    startDate: '2009-01-01',
    endDate: '2011-01-01',
    description: 'Spécialisation en Télécommunications et Réseaux',
  },
];
